function cov_10x7xo55is() {
  var path = "/app/src/components/v2/button/index.ts";
  var hash = "3c4bf7a65cf40c3d889e846e46cf9824e7af2c4c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/v2/button/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3c4bf7a65cf40c3d889e846e46cf9824e7af2c4c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10x7xo55is = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_10x7xo55is();
export { Button } from './button';